import {
  backgroundColorToTextColorConfig,
  HeroColorsV4,
  HeroColorsV5,
  CTAColor,
} from './types';
import { backgroundColorMap } from './constants';
import { ColorName } from '../../../theme';

export const transformBackgroundColor = (
  backgroundColor: HeroColorsV4 | HeroColorsV5
) => {
  return backgroundColorMap[backgroundColor] || backgroundColor;
};

export const mapBackgroundColorToV5HeadingColorName = (
  color: HeroColorsV4 | HeroColorsV5
): ColorName => {
  const colorMap: backgroundColorToTextColorConfig = {
    neutral100: 'TextDefault',
    zapier: 'BrandCream',
  };
  return colorMap[color] || 'TextInverted';
};

export const mapBackgroundColorToV5TextColorName = (
  color: HeroColorsV4 | HeroColorsV5
): ColorName => {
  const colorMap: backgroundColorToTextColorConfig = {
    neutral100: 'TextDefault',
    zapier: 'BrandCream',
  };
  return colorMap[color] || 'TextInverted';
};

export const validateZapierBackgroundAccessibility = (
  backgroundColor: HeroColorsV4 | HeroColorsV5,
  isSubscriptionForm: boolean,
  isCtaDisclaimerEnabled: boolean
) => {
  const isZapierOrange = backgroundColor === 'zapier';

  if (isZapierOrange && (isSubscriptionForm || isCtaDisclaimerEnabled)) {
    console.error(
      `Do not use the ${
        isSubscriptionForm ? 'subscription form' : 'cta disclaimer'
      } with the zapier background. ` +
        `The disclaimer text accessibility is poor on the zapier background.`
    );
  }
};

export const getSupportedCTAColor = (
  ctaColor: CTAColor,
  backgroundColor: HeroColorsV5
) => {
  const supportedCTAColors: {
    [key in HeroColorsV5]: CTAColor[];
  } = {
    // Note: Value present at 0th index is considered the default CTA color
    neutral100: ['primary', 'brand'],
    zapier: ['primary-dark'],
    night: ['primary-dark', 'brand'],
    moss: ['primary-dark', 'brand'],
    neutral800: ['primary-dark', 'brand'],
  };

  if (supportedCTAColors[backgroundColor].includes(ctaColor)) {
    return ctaColor;
  }

  return supportedCTAColors[backgroundColor][0];
};
